export interface Manga {
  id: string;
  title: string;
  author: string;
  coverImage: string;
  category: 'hanman-fu' | 'hanman-danmei' | 'riman-fu' | 'guoman-danmei';
  categoryLabel: string;
  tags: string[];
  rating: number;
  description: string;
  fullDescription: string;
  chapters: number;
  status: '连载中' | '已完结';
  updateTime: string;
  views: number;
  isHot: boolean;
  isNew: boolean;
  isRecommended: boolean;
  seoKeywords: string;
  chapterList: { num: number; title: string; date: string }[];
}

export const categories = [
  { slug: 'hanman-fu', label: '韩漫腐', icon: 'ri-heart-2-line', description: '韩国腐向漫画精选，画风精美剧情丰富' },
  { slug: 'hanman-danmei', label: '韩漫耽美', icon: 'ri-heart-pulse-line', description: '韩国耽美漫画推荐，细腻情感动人故事' },
  { slug: 'riman-fu', label: '日漫腐', icon: 'ri-sun-line', description: '日本腐向漫画经典，风格多样题材广泛' },
  { slug: 'guoman-danmei', label: '国漫耽美', icon: 'ri-fire-line', description: '国产耽美漫画新势力，原创精品不断涌现' },
];

export const mangaList: Manga[] = [
  {
    id: 'manga-001',
    title: '暗夜星辰',
    author: '墨染青衣',
    coverImage: 'https://readdy.ai/api/search-image?query=Beautiful%20romantic%20BL%20manga%20style%20illustration%20two%20handsome%20young%20men%20under%20starry%20night%20sky%2C%20soft%20warm%20lighting%2C%20emotional%20atmosphere%2C%20anime%20art%20style%2C%20delicate%20linework%2C%20dreamy%20background%20with%20stars%2C%20intimate%20moment%2C%20soft%20gradients&width=600&height=800&seq=manga-cover-001&orientation=portrait',
    category: 'hanman-fu',
    categoryLabel: '韩漫腐',
    tags: ['校园', '纯爱', '治愈'],
    rating: 9.5,
    description: '两个少年在星空下相遇，命运的齿轮开始转动。一段跨越黑暗的纯爱故事。',
    fullDescription: '在繁华都市的角落，两个性格迥异的少年因为一次偶然的相遇，命运从此紧紧相连。林星辰是一个内向安静的优等生，而韩夜则是一个外表冷酷内心温柔的转学生。他们在星空下许下约定，共同面对成长中的困惑与挑战，一段跨越黑暗的纯爱故事就此展开。画风细腻唯美，情感刻画深入人心，是近年来不可多得的韩漫腐佳作。',
    chapters: 86,
    status: '连载中',
    updateTime: '2026-08-03',
    views: 1285000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    seoKeywords: '暗夜星辰,韩漫腐,校园纯爱腐漫,治愈系腐漫',
    chapterList: [
      { num: 86, title: '第86话 星光下的约定', date: '2026-08-03' },
      { num: 85, title: '第85话 心中的答案', date: '2026-07-27' },
      { num: 84, title: '第84话 不眠之夜', date: '2026-07-20' },
      { num: 83, title: '第83话 意外的访客', date: '2026-07-13' },
      { num: 82, title: '第82话 靠近的心', date: '2026-07-06' },
    ],
  },
  {
    id: 'manga-002',
    title: '花间秘语',
    author: '樱花下的猫',
    coverImage: 'https://readdy.ai/api/search-image?query=Romantic%20BL%20manhwa%20art%20style%20two%20beautiful%20men%20surrounded%20by%20cherry%20blossoms%2C%20spring%20atmosphere%2C%20soft%20pastel%20colors%2C%20Korean%20webtoon%20style%2C%20dreamy%20floral%20background%2C%20tender%20romantic%20mood%2C%20delicate%20artwork&width=600&height=800&seq=manga-cover-002&orientation=portrait',
    category: 'hanman-danmei',
    categoryLabel: '韩漫耽美',
    tags: ['古风', '虐恋', '宫廷'],
    rating: 9.3,
    description: '深宫之中，一段禁忌之恋悄然绽放。花开花落间，谁又能守住真心？',
    fullDescription: '朝鲜时代末期，花艺师李花润被召入宫中，负责打理王世子的私家花园。在那里，他遇见了忧郁而孤独的王世子李暄。两人在花香弥漫的花园中逐渐靠近，却不知宫廷中的暗流涌动正威胁着他们的感情。一段跨越身份与禁忌的虐恋，在历史的洪流中挣扎求生。画风精致典雅，融合韩国传统美学与现代漫画技法。',
    chapters: 120,
    status: '已完结',
    updateTime: '2026-07-15',
    views: 2350000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    seoKeywords: '花间秘语,韩漫耽美,古风腐漫,宫廷虐恋腐漫',
    chapterList: [
      { num: 120, title: '第120话 花落花开（终章）', date: '2026-07-15' },
      { num: 119, title: '第119话 最后的抉择', date: '2026-07-08' },
      { num: 118, title: '第118话 真相大白', date: '2026-07-01' },
      { num: 117, title: '第117话 暴风雨前', date: '2026-06-24' },
      { num: 116, title: '第116话 王命', date: '2026-06-17' },
    ],
  },
  {
    id: 'manga-003',
    title: '东京恋语',
    author: '浅井悠',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20BL%20manga%20illustration%20two%20young%20men%20walking%20through%20Tokyo%20cityscape%20at%20sunset%2C%20warm%20golden%20light%2C%20modern%20urban%20setting%2C%20emotional%20connection%2C%20anime%20art%20style%2C%20beautiful%20composition%2C%20romantic%20mood&width=600&height=800&seq=manga-cover-003&orientation=portrait',
    category: 'riman-fu',
    categoryLabel: '日漫腐',
    tags: ['都市', '职场', '治愈'],
    rating: 9.4,
    description: '东京的霓虹灯下，两个疲惫的灵魂找到了彼此的港湾。',
    fullDescription: '在东京这座不夜城中，广告公司职员佐藤翔太每天过着朝九晚九的疲惫生活。直到有一天，他在深夜的便利店里遇到了同样加班到深夜的设计师高桥诚。一次偶然的搭话，让两个孤独的灵魂开始靠近。他们在东京的夜色中漫步，分享着彼此的梦想与不安。一部温暖治愈的都市腐漫，细腻描绘了都市打工人的真实生活与感情。',
    chapters: 64,
    status: '连载中',
    updateTime: '2026-08-02',
    views: 980000,
    isHot: true,
    isNew: false,
    isRecommended: false,
    seoKeywords: '东京恋语,日漫腐,都市职场腐漫,治愈系日漫',
    chapterList: [
      { num: 64, title: '第64话 黎明之前', date: '2026-08-02' },
      { num: 63, title: '第63话 未说出口的话', date: '2026-07-26' },
      { num: 62, title: '第62话 雨中的约定', date: '2026-07-19' },
      { num: 61, title: '第61话 新的开始', date: '2026-07-12' },
      { num: 60, title: '第60话 真心', date: '2026-07-05' },
    ],
  },
  {
    id: 'manga-004',
    title: '剑心如梦',
    author: '云中鹤',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20danmei%20manhua%20art%20style%20two%20elegant%20swordsmen%20in%20ancient%20Chinese%20setting%2C%20flowing%20robes%2C%20bamboo%20forest%20background%2C%20martial%20arts%20theme%2C%20ink%20wash%20painting%20aesthetic%2C%20romantic%20tension%2C%20soft%20moonlight&width=600&height=800&seq=manga-cover-004&orientation=portrait',
    category: 'guoman-danmei',
    categoryLabel: '国漫耽美',
    tags: ['武侠', '江湖', '古风'],
    rating: 9.6,
    description: '江湖路远，剑光如雪。两个绝世剑客的爱恨纠缠。',
    fullDescription: '武林中有两位绝世剑客——白如镜与沈墨渊，一正一邪，互为宿敌。然而在一次秘境探险中，两人被迫联手对敌，逐渐发现彼此并非想象中的那么简单。从敌对到相知，从相知到相惜，一段跨越正邪的爱情在刀光剑影中悄然生长。国风水墨画风，大气磅礴的江湖场景，细腻的情感刻画，被誉为国漫耽美的里程碑之作。',
    chapters: 150,
    status: '连载中',
    updateTime: '2026-08-04',
    views: 3210000,
    isHot: true,
    isNew: true,
    isRecommended: true,
    seoKeywords: '剑心如梦,国漫耽美,武侠腐漫,江湖古风腐漫',
    chapterList: [
      { num: 150, title: '第150话 剑指苍穹', date: '2026-08-04' },
      { num: 149, title: '第149话 秘境之谜', date: '2026-07-28' },
      { num: 148, title: '第148话 联手', date: '2026-07-21' },
      { num: 147, title: '第147话 各怀心思', date: '2026-07-14' },
      { num: 146, title: '第146话 狭路相逢', date: '2026-07-07' },
    ],
  },
  {
    id: 'manga-005',
    title: '薄荷糖之吻',
    author: '苏打气泡',
    coverImage: 'https://readdy.ai/api/search-image?query=Sweet%20BL%20manhwa%20style%20illustration%20two%20high%20school%20boys%20sharing%20earphones%20in%20classroom%2C%20sunlight%20streaming%20through%20windows%2C%20youthful%20innocent%20atmosphere%2C%20soft%20pastel%20colors%2C%20Korean%20webtoon%20style%2C%20first%20love%20theme&width=600&height=800&seq=manga-cover-005&orientation=portrait',
    category: 'hanman-fu',
    categoryLabel: '韩漫腐',
    tags: ['校园', '甜宠', '初恋'],
    rating: 9.2,
    description: '一颗薄荷糖，一场甜蜜的初恋。高中校园里最纯粹的心动。',
    fullDescription: '转学生金夏恩第一天来到新学校，就被同桌李泰俊塞了一颗薄荷糖。从那以后，薄荷糖成了两人之间的小秘密。从最初的陌生到逐渐熟悉，从朋友到心中暗藏的情愫。在高中校园的青葱岁月里，一段甜蜜纯真的初恋悄然绽放。没有虐心，只有满满的甜蜜和温暖，让人看完忍不住嘴角上扬。',
    chapters: 45,
    status: '连载中',
    updateTime: '2026-08-01',
    views: 756000,
    isHot: false,
    isNew: true,
    isRecommended: true,
    seoKeywords: '薄荷糖之吻,韩漫腐,校园甜宠腐漫,初恋腐漫',
    chapterList: [
      { num: 45, title: '第45话 薄荷味的夏天', date: '2026-08-01' },
      { num: 44, title: '第44话 心跳加速', date: '2026-07-25' },
      { num: 43, title: '第43话 两个人的秘密', date: '2026-07-18' },
      { num: 42, title: '第42话 靠近', date: '2026-07-11' },
      { num: 41, title: '第41话 糖果', date: '2026-07-04' },
    ],
  },
  {
    id: 'manga-006',
    title: '月下长安',
    author: '柳如烟',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20danmei%20manhua%20illustration%20two%20handsome%20men%20in%20Tang%20dynasty%20attire%20under%20full%20moon%2C%20ancient%20Chinese%20palace%20rooftops%2C%20romantic%20moonlit%20night%2C%20traditional%20Chinese%20art%20aesthetic%2C%20flowing%20fabrics%2C%20elegant%20composition&width=600&height=800&seq=manga-cover-006&orientation=portrait',
    category: 'guoman-danmei',
    categoryLabel: '国漫耽美',
    tags: ['古风', '宫廷', '权谋'],
    rating: 9.7,
    description: '大唐盛世，月下的长安城藏着多少不为人知的秘密与深情。',
    fullDescription: '唐贞观年间，少年将军裴云起与翰林学士沈清辞因一桩宫廷谜案相识。一个是骁勇善战的将军，一个是才华横溢的文臣，在步步惊心的权谋斗争中，两人从互不信任到并肩作战。月光下的长安城见证了他们的智慧、勇气与深情。宏大历史背景下的耽美佳作，既有朝堂权谋的精彩，又有儿女情长的动人。',
    chapters: 98,
    status: '连载中',
    updateTime: '2026-08-03',
    views: 1890000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    seoKeywords: '月下长安,国漫耽美,宫廷权谋腐漫,古风耽美',
    chapterList: [
      { num: 98, title: '第98话 棋局', date: '2026-08-03' },
      { num: 97, title: '第97话 暗线', date: '2026-07-27' },
      { num: 96, title: '第96话 朝堂之上', date: '2026-07-20' },
      { num: 95, title: '第95话 月色如水', date: '2026-07-13' },
      { num: 94, title: '第94话 旧事重提', date: '2026-07-06' },
    ],
  },
  {
    id: 'manga-007',
    title: '樱花落尽之时',
    author: '渡边静',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20BL%20manga%20illustration%20two%20men%20under%20falling%20cherry%20blossoms%20in%20traditional%20Japanese%20garden%2C%20melancholic%20spring%20atmosphere%2C%20yukata%20clothing%2C%20soft%20pink%20petals%2C%20emotional%20farewell%20scene%2C%20traditional%20Japanese%20art%20style&width=600&height=800&seq=manga-cover-007&orientation=portrait',
    category: 'riman-fu',
    categoryLabel: '日漫腐',
    tags: ['和风', '虐恋', '时代'],
    rating: 9.0,
    description: '樱花飘落的季节，一段跨越时代的悲恋物语。',
    fullDescription: '大正时代的日本，没落华族子弟藤原雅人与新兴商人子弟田中翔在樱花树下相识。两个来自不同世界的人，却在彼此的眼中看到了相同的孤独。然而时代洪流与家族责任将两人推向不同的方向。当樱花再次飘落，他们还能否再次相遇？以日本大正浪漫为背景的腐向漫画，画风唯美，故事感人至深。',
    chapters: 72,
    status: '已完结',
    updateTime: '2026-06-20',
    views: 1560000,
    isHot: false,
    isNew: false,
    isRecommended: false,
    seoKeywords: '樱花落尽之时,日漫腐,大正浪漫腐漫,和风虐恋',
    chapterList: [
      { num: 72, title: '第72话 重逢（终章）', date: '2026-06-20' },
      { num: 71, title: '第71话 各自的远方', date: '2026-06-13' },
      { num: 70, title: '第70话 告别', date: '2026-06-06' },
      { num: 69, title: '第69话 最后的花见', date: '2026-05-30' },
      { num: 68, title: '第68话 风暴', date: '2026-05-23' },
    ],
  },
  {
    id: 'manga-008',
    title: '逆光之翼',
    author: '玄色',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20webtoon%20art%20style%20two%20young%20men%20with%20angel%20wings%20theme%2C%20ethereal%20light%20beams%2C%20fantasy%20setting%2C%20one%20light%20one%20dark%20contrast%2C%20dramatic%20composition%2C%20heavenly%20atmosphere%2C%20semi-realistic%20anime%20art&width=600&height=800&seq=manga-cover-008&orientation=portrait',
    category: 'hanman-danmei',
    categoryLabel: '韩漫耽美',
    tags: ['奇幻', '天使', '虐恋'],
    rating: 9.1,
    description: '天使与堕天使，光明与黑暗，禁忌之恋能否跨越天堂与地狱？',
    fullDescription: '天使艾尔被派往人间执行任务时，遇到了堕天使路西法。按照天界的法则，天使与堕天使势不两立。然而在一次次交锋中，艾尔发现路西法并非传说中的那般邪恶。两人在光明与黑暗的边缘徘徊，试图找到一条属于他们的第三条路。奇幻设定下的虐心耽美，探讨了善恶、信仰与爱的本质。',
    chapters: 55,
    status: '连载中',
    updateTime: '2026-07-30',
    views: 1120000,
    isHot: true,
    isNew: true,
    isRecommended: false,
    seoKeywords: '逆光之翼,韩漫耽美,奇幻腐漫,天使耽美',
    chapterList: [
      { num: 55, title: '第55话 光与暗的交界', date: '2026-07-30' },
      { num: 54, title: '第54话 选择', date: '2026-07-23' },
      { num: 53, title: '第53话 真相的碎片', date: '2026-07-16' },
      { num: 52, title: '第52话 坠落', date: '2026-07-09' },
      { num: 51, title: '第51话 天界之令', date: '2026-07-02' },
    ],
  },
  {
    id: 'manga-009',
    title: '电竞之王',
    author: '零度',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20danmei%20manhua%20illustration%20two%20young%20male%20esports%20players%20in%20gaming%20arena%2C%20neon%20lights%2C%20competitive%20atmosphere%2C%20wearing%20team%20jerseys%2C%20intense%20gaming%20moment%2C%20modern%20Chinese%20comic%20style%2C%20dynamic%20composition&width=600&height=800&seq=manga-cover-009&orientation=portrait',
    category: 'guoman-danmei',
    categoryLabel: '国漫耽美',
    tags: ['电竞', '热血', '竞技'],
    rating: 9.3,
    description: '从路人到队友，从队友到恋人，电竞舞台上的热血与爱情。',
    fullDescription: '天赋异禀的电竞选手陆远因与战队不合而选择退役。一年后，他被新晋战队经理顾言邀请回归。从最初的磨合碰撞，到并肩作战的默契，他们在追逐冠军的道路上，也走近了彼此的心。真实还原电竞圈生态，热血与甜蜜并存，让读者感受到电竞的激情与爱情的美好。',
    chapters: 78,
    status: '连载中',
    updateTime: '2026-08-04',
    views: 2010000,
    isHot: true,
    isNew: true,
    isRecommended: true,
    seoKeywords: '电竞之王,国漫耽美,电竞腐漫,热血竞技腐漫',
    chapterList: [
      { num: 78, title: '第78话 总决赛', date: '2026-08-04' },
      { num: 77, title: '第77话 决胜局', date: '2026-07-28' },
      { num: 76, title: '第76话 逆风翻盘', date: '2026-07-21' },
      { num: 75, title: '第75话 战术', date: '2026-07-14' },
      { num: 74, title: '第74话 对手', date: '2026-07-07' },
    ],
  },
  {
    id: 'manga-010',
    title: '猫咪咖啡厅',
    author: '春日井暖',
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20BL%20manga%20illustration%20two%20young%20men%20in%20cozy%20cat%20cafe%20surrounded%20by%20cats%2C%20warm%20interior%20lighting%2C%20cozy%20atmosphere%2C%20slice%20of%20life%20theme%2C%20gentle%20colors%2C%20cute%20and%20heartwarming%20mood%2C%20casual%20clothing&width=600&height=800&seq=manga-cover-010&orientation=portrait',
    category: 'riman-fu',
    categoryLabel: '日漫腐',
    tags: ['日常', '治愈', '萌宠'],
    rating: 9.0,
    description: '一家温馨的猫咪咖啡厅，两只小猫和两个温柔的人。',
    fullDescription: '大学毕业生小林优在求职失败后，偶然走进了一家名为"猫之森"的咖啡厅。咖啡厅老板宫崎和臣是个温柔寡言的人，却对猫咪有着无限的爱。小林开始在咖啡厅打工，在日常的相处中，两人和一群可爱的猫咪之间发生了许多温暖的小故事。轻松治愈的日常向腐漫，搭配可爱的猫咪元素，让人在繁忙中得到片刻治愈。',
    chapters: 36,
    status: '连载中',
    updateTime: '2026-07-28',
    views: 520000,
    isHot: false,
    isNew: true,
    isRecommended: false,
    seoKeywords: '猫咪咖啡厅,日漫腐,日常治愈腐漫,萌宠腐漫',
    chapterList: [
      { num: 36, title: '第36话 新来的小猫', date: '2026-07-28' },
      { num: 35, title: '第35话 雨天的客人', date: '2026-07-21' },
      { num: 34, title: '第34话 猫咪生病了', date: '2026-07-14' },
      { num: 33, title: '第33话 两个人的采购日', date: '2026-07-07' },
      { num: 32, title: '第32话 夏日祭典', date: '2026-06-30' },
    ],
  },
  {
    id: 'manga-011',
    title: '绯月之下',
    author: '紫蝶',
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20BL%20webtoon%20art%20with%20vampire%20theme%2C%20two%20mysterious%20men%20under%20red%20moon%2C%20gothic%20atmosphere%2C%20dark%20romantic%20fantasy%2C%20elegant%20Victorian%20style%20clothing%2C%20dramatic%20lighting%2C%20blood%20red%20accents&width=600&height=800&seq=manga-cover-011&orientation=portrait',
    category: 'hanman-danmei',
    categoryLabel: '韩漫耽美',
    tags: ['吸血鬼', '奇幻', '暗黑'],
    rating: 9.4,
    description: '吸血鬼猎人与纯血吸血鬼——命中注定的相遇与纠缠。',
    fullDescription: '吸血鬼猎人崔俊浩在一次任务中遇到了纯血吸血鬼尹赫。按照猎人的铁律，他应该毫不犹豫地消灭对方。但尹赫身上似乎藏着一个关于吸血鬼起源的巨大秘密。为了揭开真相，两人开始了亦敌亦友的同行。在追查真相的过程中，一段不被允许的感情也在暗中滋长。',
    chapters: 92,
    status: '连载中',
    updateTime: '2026-08-02',
    views: 1680000,
    isHot: true,
    isNew: false,
    isRecommended: true,
    seoKeywords: '绯月之下,韩漫耽美,吸血鬼腐漫,暗黑奇幻腐漫',
    chapterList: [
      { num: 92, title: '第92话 古老的真相', date: '2026-08-02' },
      { num: 91, title: '第91话 对决', date: '2026-07-26' },
      { num: 90, title: '第90话 地下的秘密', date: '2026-07-19' },
      { num: 89, title: '第89话 血之契约', date: '2026-07-12' },
      { num: 88, title: '第88话 猎人集会', date: '2026-07-05' },
    ],
  },
  {
    id: 'manga-012',
    title: '江湖夜雨',
    author: '墨白',
    coverImage: 'https://readdy.ai/api/search-image?query=Chinese%20danmei%20manhua%20two%20martial%20artists%20in%20rainy%20night%20ancient%20Chinese%20street%2C%20lanterns%20glowing%2C%20wet%20stone%20pavement%2C%20ink%20brush%20painting%20style%2C%20romantic%20yet%20melancholic%2C%20traditional%20rooftops%2C%20atmospheric%20night%20scene&width=600&height=800&seq=manga-cover-012&orientation=portrait',
    category: 'guoman-danmei',
    categoryLabel: '国漫耽美',
    tags: ['武侠', '悬疑', '江湖'],
    rating: 9.5,
    description: '江湖夜雨十年灯，一桩迷案牵出两代人的恩怨情仇。',
    fullDescription: '江湖上突然出现了一系列离奇命案，被害者都是各大门派的掌门人。正道少侠顾清风与魔教少主夜无痕因为调查同一桩案件而命运交织。在揭开真相的过程中，他们发现这背后竟然牵扯到二十年前一桩被掩盖的惨案。而两人的身世之谜也渐渐浮出水面……',
    chapters: 110,
    status: '连载中',
    updateTime: '2026-08-04',
    views: 2780000,
    isHot: true,
    isNew: true,
    isRecommended: true,
    seoKeywords: '江湖夜雨,国漫耽美,武侠悬疑腐漫,江湖腐漫',
    chapterList: [
      { num: 110, title: '第110话 身世之谜', date: '2026-08-04' },
      { num: 109, title: '第109话 雨夜追踪', date: '2026-07-28' },
      { num: 108, title: '第108话 线索', date: '2026-07-21' },
      { num: 107, title: '第107话 魔教秘闻', date: '2026-07-14' },
      { num: 106, title: '第106话 夜探', date: '2026-07-07' },
    ],
  },
];

export const getMangaByCategory = (slug: string): Manga[] => {
  return mangaList.filter((m) => m.category === slug);
};

export const getMangaById = (id: string): Manga | undefined => {
  return mangaList.find((m) => m.id === id);
};

export const getHotManga = (limit: number = 6): Manga[] => {
  return mangaList.filter((m) => m.isHot).slice(0, limit);
};

export const getNewManga = (limit: number = 6): Manga[] => {
  return mangaList.filter((m) => m.isNew).slice(0, limit);
};

export const getRecommendedManga = (limit: number = 8): Manga[] => {
  return mangaList.filter((m) => m.isRecommended).slice(0, limit);
};

export const siteInfo = {
  name: '腐漫画网',
  tagline: '好看腐漫热门推荐大全',
  description: '腐漫画网集结韩漫腐、韩漫耽美、日漫腐、国漫耽美等风格腐漫，精选好看腐漫与热门腐漫推荐，免费全集下拉式随心看。',
  email: 'contact@fumanhua.com',
  foundingYear: '2024',
  stats: {
    totalManga: '10000+',
    dailyVisitors: '50万+',
    totalChapters: '50万+',
    satisfaction: '98%',
  },
};